import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Page from '../views/Page.vue'
import axios from 'axios'
import GroupedPage from '../views/GroupedPage.vue'
import IndexPage from '../views/IndexPage.vue'
import MapPage from '../views/MapPage.vue'
import ContactForm from '../views/ContactForm.vue'
import SubmitContent from '../views/SubmitContent.vue'
import CustomPage from '../views/CustomPage.vue'
import TestComp from '../components/TestComp.vue'
import NotFoundPage from '../views/404.vue'
import SearchIndexPage from '../views/SearchIndexPage.vue'
import PromotionalPage from '../views/PromotionalPage.vue'
Vue.use(VueRouter)

var routes = [
  {
    path: 'TrailMap',
    name: 'trailmap',
    component: MapPage,
    props: true
  },
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      to.meta.fromHistory = true
      return savedPosition
    } else {
      to.meta.fromHistory = false
      // when going from map page to a child slide-out page preserve location
      if (from.matched.every(val => to.matched.includes(val))) {
        return null;
      // when going from a slide-out page to the parent map page preserve location
      } else if (to.matched.every(val => from.matched.includes(val))) {
        return null;
      // else reset to the top of the page
      } else {
        return { x: 0, y: 0 };
      }
    }
  },
  base: undefined,
  routes

})

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
    // console.log(nearestWithTitle)
  }
  next();
})

get_routes().then(data =>{
    for (let i = 0; i < data.length; i++) {
      if (data[i].meta.content_type === 8) {
        data[i]['component'] = Home
      }

      else if (data[i].meta.content_type === 18) {
        // console.log('IP') 
        data[i]['component'] = IndexPage
      }
      else if (data[i].meta.content_type === 13) {
        console.log('CP')
        data[i]['component'] = CustomPage
      }
      else {
        console.log('ELSE PAGE')
        data[i]['component'] = Page
      }
    }
    data.push({'path': '/404', 'name': '404', 'component': NotFoundPage})
    data.push({'path': '*', 'redirect': '/404'})
    console.log(data)
    router.addRoutes(data)
    
   
})

function get_routes() {
  return axios.get('/api/all_urls').then(response => {
    return response.data
  })
}

export default router